var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"svgToPngContainer"},[_c('span',{staticClass:"badge badge-secondary pointer",staticStyle:{"background-color":"#CACACA"},on:{"click":function($event){return _vm.download()}}},[_vm._v("download\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }